<template>
  <div>
    <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mb-5">
      <div class="rounded-xl p-4 bg-gradient-to-br from-gray-50 to-white border">
        <div class="text-gray-500 text-xs">Registrations</div>
        <div class="text-2xl font-semibold">{{ surveyStats.total_registrations || 0 }}</div>
      </div>
      <div class="rounded-xl p-4 bg-gradient-to-br from-gray-50 to-white border">
        <div class="text-gray-500 text-xs">Registrations with answers</div>
        <div class="text-2xl font-semibold">{{ surveyStats.responders || 0 }}</div>
      </div>
      <div class="rounded-xl p-4 bg-gradient-to-br from-gray-50 to-white border">
        <div class="text-gray-500 text-xs">Answer coverage</div>
        <div class="text-2xl font-semibold">{{ surveyStats.response_rate_pct || 0 }}%</div>
      </div>
      <div class="rounded-xl p-4 bg-gradient-to-br from-gray-50 to-white border">
        <div class="text-gray-500 text-xs">Question completion</div>
        <div class="text-2xl font-semibold">{{ surveyStats.question_completion_rate_pct || 0 }}%</div>
      </div>
    </div>

    <div v-if="surveyStats.graduate_participants !== undefined" class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5">
      <div class="rounded-xl p-4 bg-white border">
        <div class="text-gray-500 text-xs">Graduates who answered an assigned survey</div>
        <div class="text-2xl font-semibold">{{ surveyStats.graduate_participants }}</div>
        <p class="text-xs text-gray-500">Preserved across amendments. Imports and blank optional answers do not count. {{ surveyStats.participation_unknown || 0 }} assigned registrations have unknown survey participation.</p>
      </div>
      <div class="rounded-xl p-4 bg-white border">
        <div class="text-gray-500 text-xs">Assigned survey requirements satisfied</div>
        <div class="text-2xl font-semibold">{{ surveyStats.current_required_complete }}</div>
        <p class="text-xs text-gray-500">Valid mapped data can satisfy these questions. New requirements can reduce this count. {{ surveyStats.current_completion_unknown || 0 }} assigned registrations await assessment.</p>
      </div>
    </div>
    <div>
      <div class="text-sm font-semibold mb-2">Top unanswered questions</div>
      <div v-if="!(surveyStats.top_unanswered_questions || []).length" class="text-sm text-gray-500">No unanswered-question data in scope.</div>
      <div v-else class="overflow-x-auto border rounded-lg bg-white">
        <table class="min-w-full text-sm">
          <thead class="bg-gray-50 text-gray-600">
            <tr>
              <th class="text-left px-3 py-2">Question</th>
              <th class="text-left px-3 py-2">Type</th>
              <th class="text-right px-3 py-2">
                Eligible
                <span class="ml-1 text-gray-400 cursor-help text-xs info-tip" :title="tooltips.survey_eligible" role="img" aria-label="Info">ⓘ</span>
              </th>
              <th class="text-right px-3 py-2">Answered</th>
              <th class="text-right px-3 py-2">Unanswered</th>
              <th class="text-right px-3 py-2">Answer rate</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="q in (surveyStats.top_unanswered_questions || []).slice(0, 10)" :key="`uq-${q.question_key}`" class="border-t">
              <td class="px-3 py-2">
                <div>{{ questionTitle(q) }}</div>
                <div v-if="q.question_context" class="text-xs text-gray-600 mt-1">{{ q.question_context }}</div>
              </td>
              <td class="px-3 py-2">{{ q.question_type }}</td>
              <td class="px-3 py-2 text-right">{{ q.eligible_count }}</td>
              <td class="px-3 py-2 text-right">{{ q.answered_count }}</td>
              <td class="px-3 py-2 text-right">{{ q.unanswered_count }}</td>
              <td class="px-3 py-2 text-right">{{ q.answer_rate_pct }}%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { questionTitle } from './questionLabels'
export default {
  name: 'SurveyOverviewSection',
  methods: { questionTitle },
  props: {
    surveyStats: { type: Object, required: true },
    tooltips: { type: Object, default: () => ({}) },
  },
}
</script>
